import { render, staticRenderFns } from "./FeaturesSection.vue?vue&type=template&id=e7097292&scoped=true"
import script from "./FeaturesSection.vue?vue&type=script&lang=ts"
export * from "./FeaturesSection.vue?vue&type=script&lang=ts"
import style0 from "./FeaturesSection.vue?vue&type=style&index=0&id=e7097292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7097292",
  null
  
)

export default component.exports